import { createSlice } from "@reduxjs/toolkit";
import { GET_DASHBOARD_ANALYTICS_ACTION } from "./Dashboard.action";
const DashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        loading: false,
        error: null,
        analytics: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_DASHBOARD_ANALYTICS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_DASHBOARD_ANALYTICS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.analytics = action.payload.r;
            })
            .addCase(GET_DASHBOARD_ANALYTICS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default DashboardSlice;